import { ObserverService } from '@DavisDigital/davisdigitalfrontend.module';

import { EVENTS } from '../interfaces';

class ImageGallerySlideshowController {
	
	public contentModule;
	public deleteContentModule; 
	public images;
	public launchSlideshowModal;
	public toggleEdit;
	public viewType;
	
	// @ngInject
	constructor(
		public $timeout : ng.ITimeoutService,
		public observerService : ObserverService
	){}
	
	public $onInit = () => {
		this.observerService.attach(this.reinitializeSlick, EVENTS.UPDATE_CONTENT_MODULES)
	}
	
	public $onDestroy = () =>{
		this.destroySlick;
	}
	
	public reinitializeSlick = () =>{
		this.destroySlick();
		this.initializeSlick();
	}
	
	public initializeSlick = () =>{
		var controller = this;
		this.$timeout(()=>{
			//this is a workaround for adaptive height, when true the first image does not load, without the timeout
			//you get can't call slickGoTo on undefined, for some reason slick is not defined when the init event is called. 
			$('.slider__module .slider-nav').on('init', (event, slick) => {
				this.$timeout(()=>{
					$('.slider__module .slider-nav').slick('slickGoTo',0);
				},2000)
			});
			
			$('.slider__module .slider-for').on('init', (event, slick) => {
				this.$timeout(()=>{
					controller.addImagesDimensions();
				},2000)
			});
			
			$('.slider__module .slider-for').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				adaptiveHeight: true,
				arrows: true,
				asNavFor: '.slider__module .slider-nav',
				lazyLoad: 'ondemand',
				prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><i class="fal fa-angle-left"></i></button>',
				nextArrow: '<button class="slick-next" aria-label="Next" type="button"><i class="fal fa-angle-right"></i></button>'
			});

			$('.slider__module .slider-nav').slick({
				arrows: false,
				slidesToShow: 8,
				slidesToScroll: 1,
				asNavFor: '.slider__module .slider-for',
				focusOnSelect: true,
				variableWidth: true,
			});
			
		});
	}
	
	public addImagesDimensions = () => {
		
		if( $(".slider-nav").length ) {
			$(".slider-nav img").each(function(){
				// Slideshow Thumbnails
				var imageDirectionClass = ( $(this).width() > $(this).height() )? "horizontal" : "vertical";
				$(this).addClass(imageDirectionClass);
			});	
		}
		
		if( $(".slider-for").length ) {
			$(".slider-for img").each(function(){
				// Slideshow Images
				var imageDirectionClass = ( $(this).width() > $(this).height() )? "horizontal" : "vertical";
				$(this).addClass(imageDirectionClass);
			});	
		}		
	}
	
	public destroySlick = () =>{
		$('.slider__module .slider-for').slick('unslick');
		$('.slider__module .slider-nav').slick('unslick');
	}
	
}

class ImageGallerySlideshow {
	
	public restrict: string = 'EA';
	public scope: boolean = true;
	
	public bindToController: any = {
		contentModule : '=',
		deleteContentModule : '&',
		images : '=',
		launchSlideshowModal : '&',
		toggleEdit : '&',
		viewType: '=?'
	};

	public controller = ImageGallerySlideshowController;
	public controllerAs = 'imageGallerySlideshow';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/image-gallery-slideshow.html';

	public static Factory() {
		var directive = ($timeout) => new this($timeout);
		directive.$inject = ['$timeout'];
		return directive;
	}
	
	//@ngInject
    constructor(private $timeout){
    }
	
	public link:ng.IDirectiveLinkFn = (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs:ng.IAttributes) =>{
		scope.imageGallerySlideshow.initializeSlick();
    }
}

export { ImageGallerySlideshow };
